import _ from "lodash";
import h from "./createElement";

export default class Modal {
    component = null;
    /**@type {HTMLElement} */
    current = null;

    _close_ext_listener;
    _prop_on_close;

    constructor(Component) {
        if (!Component) throw new Error('O contrutor do modal precisa da referência de um componente');
        this.component = Component;
    };

    show(props) {
        if (this.current && this.current.isConnected) return this;
        /**@type {HTMLElement} */
        const wrapper = inject_wrapper();

        let init, zindex = _.reduce(wrapper.querySelectorAll("section.overlay"), (ac, c) => ac + 20, 100)

        const overlay_n_child = h('section',
            { class: 'overlay', style: `--zidx: ${zindex};` },
            h("section", { class: "modal-content" },
                h(this.component, { ...props, hide: (callback, smooth) => this.hide(callback, smooth), onInit: (fn) => init = fn, onHide: (fn) => this._prop_on_close = fn })
            )
        );

        wrapper.appendChild(overlay_n_child);

        this.current = overlay_n_child;

        if (init) init();
        return this;
    };

    overlay_click_hide(callback) {
        if (this.current && this._close_ext_listener) return
        this._close_ext_listener = e => {
            if (e.target.matches('section.overlay')) this.hide(callback);
            this.current.removeEventListener("click", this._close_ext_listener);
            this._close_ext_listener = null;
        }
        this.current.addEventListener("click", this._close_ext_listener);
    };

    hide(callback, smooth = true) {
        if (this.current && this.current.isConnected) {
            if (this._prop_on_close) this._prop_on_close();
            if (!smooth) return this.current.remove();

            const remove = () => {
                this.current.remove();
                this.current.removeEventListener("animationend", remove);
                this.current.removeEventListener("click", this._close_ext_listener);
                this._close_ext_listener = null;
                this._prop_on_close = null;
                callback && callback();
            };

            this.current.addEventListener("animationend", remove);
            this.current.classList.add("closing");
        };
    };

    get is_opened() { return !!this.current?.isConnected }
};

function inject_wrapper() {
    const main_section = document.querySelector('section.modal-wrapper') || h('section', { class: 'modal-wrapper' });
    if (!main_section.isConnected) document.body.appendChild(main_section);
    return main_section
};